// extracted by mini-css-extract-plugin
export default {"wrapper":"NavbarAdmin_wrapper__ad7xZ","wrapper_nav":"NavbarAdmin_wrapper_nav__wnffP","item_nav":"NavbarAdmin_item_nav__NSDpV"};